import { ROUTE_PATHS } from 'constants/index'
import { lazy } from 'react'

const PredictionMarket = lazy(() => import('games/PredictionMarket/index'))
// const MarketInner = lazy(() => import('games/PredictionMarket/MarketDetail/MarketInner/index'))

const routesList = [
  {
    path: ROUTE_PATHS.predictionMarket,
    component: PredictionMarket,
    isPrivate: false,
    isHeader: false,
    isFooter: false
  },
  {
    path: `${ROUTE_PATHS.predictionMarket}/:page(markets|market-detail|portfolio)`,
    component: PredictionMarket,
    isPrivate: false,
    isHeader: false,
    isFooter: false
  },
  // {
  //   path: ROUTE_PATHS.MarketInner,
  //   component: MarketInner,
  //   isPrivate: false,
  //   isHeader: true,
  //   isFooter: false
  // }
]

export default routesList
